module.exports = __webpack_public_path__ + "img/icon_instagram.bc8a72a0.svg";